
import styled from "styled-components";

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export function ProductImageCard({ imageComponent, title, subtitle, rightDiv, innerDiv, footerDiv }) {
  return (
    <>
      <div className="d-flex align-items-center">
        {imageComponent}
        <FlexColumn className="ml-3" style={{ flex: 1, minWidth: 0 }}>
          <span className="fs-16 fw-600">{title}</span>
          <div className="d-flex align-items-center justify-content-between mt-1">
            <span className="fs-14 fw-400 text-gray-cool">{subtitle}</span>
            {rightDiv}
          </div>
        </FlexColumn>
      </div>
      {innerDiv}
      {footerDiv}
    </>
  );
}

export default ProductImageCard;
